import { updateUI } from 'shared/redux/interface'
const store = window.booqableStore

export default {
  setItem (id) {
    const action = updateUI('Quickview', { itemId: id })

    return store.dispatch(action)
  },

  unsetItem () {
    const action = updateUI('Quickview', { itemId: null })

    return store.dispatch(action)
  }
}
